import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import SimpleTable from '../../components/super/SimpleTable';

function SettingsOverview() {
    const systemSettings = [
        {
            category: 'Slack',
            name: 'ui.slack_allowed',
            description:
                'Allow Slack integration - Activated on integration page',
            example: '0 | 1',
        },
        {
            category: 'Slack',
            name: 'slack.welcomeMessage',
            description:
                'If Welcome message for initial Slack communication should be sent',
            example: '0 | 1',
        },
        {
            category: 'Slack',
            name: 'ui.slackOnly',
            description:
                '(DEPRECATED) Only show option to send messages to slack',
            example: '0 | 1',
        },
        {
            category: 'Slack',
            name: 'slack.noEmails',
            description: '(DEPRECATED) Only send messages to slack',
            example: '0 | 1',
        },
        {
            category: 'Teams',
            name: 'msteams.bot_id',
            description: 'Id of bot used for Teams',
            example: '',
        },
        {
            category: 'Teams',
            name: 'msteams.bot_pwd',
            description: 'Password for bot used for Teams',
            example: '',
        },
        {
            category: 'Teams',
            name: 'teams.enabled',
            description: 'If Teams has been initalized',
            example: '0 | 1',
        },
        {
            category: 'Teams',
            name: 'msteams.show_welcome',
            description:
                'If Welcome message for initial Teams communication should be sent',
            example: '0 | 1',
        },
        {
            category: 'Azure/Active Directory',
            name: 'azure.tenant',
            description: 'Tenant id  - usually entered by customer',
            example: '',
        },
        {
            category: 'Azure/Active Directory',
            name: 'azure.clientId',
            description: 'Client id from Azure - usually entered by customer',
            example: '',
        },
        {
            category: 'Azure/Active Directory',
            name: 'azure.clientSecret',
            description:
                'Secret string from Azure - usually entered by customer',
            example: '',
        },
        {
            category: 'Azure/Active Directory',
            name: 'azure.testMode',
            description: '(DEPRECATED) Enable test mode in AD integration',
            example: '',
        },
        {
            category: 'Azure/Active Directory',
            name: 'azure.enabled',
            description: 'Azure is enabled',
            example: '0 | 1',
        },
        {
            category: 'Azure/Active Directory',
            name: 'azure.groupBehaviour',
            description: '(DEPRECATED) Active directory behaviour',
            example: 'include | exclude',
        },
        {
            category: 'Azure/Active Directory',
            name: 'ui.adi_allowed',
            description:
                'Show Active Directory option in UI - on integration page',
            example: '0 | 1',
        },
        {
            category: 'Microsoft Defender AST (platform)',
            name: 'internal.microsoft_defender_ast.client_id',
            description:
                'Multi-tenant Entra application (client) ID for Attack Simulation Training Graph calls. Overrides MICROSOFT_DEFENDER_AST_CLIENT_ID when set.',
            example: '',
        },
        {
            category: 'Microsoft Defender AST (platform)',
            name: 'internal.microsoft_defender_ast.client_secret',
            description:
                'Client secret for that app (client credentials). Overrides MICROSOFT_DEFENDER_AST_CLIENT_SECRET when set.',
            example: '',
        },
        {
            category: 'Microsoft Defender AST (platform)',
            name: 'internal.microsoft_defender_ast.redirect_uri',
            description:
                'OAuth admin-consent redirect URI; must match the app registration. Overrides MICROSOFT_DEFENDER_AST_REDIRECT_URI; default is API_URL + /microsoft-defender-ast/callback.',
            example: 'https://api.example.com/microsoft-defender-ast/callback',
        },
        {
            category: 'OWASP training demo (platform)',
            name: 'internal.owasp_training_demo.enabled',
            description:
                'Enable the public LMS demo at /owasp-training-demo and POST /public/owasp-training-demo/generate. Requires ANTHROPIC_API_KEY or OPENAI_API_KEY on the API service.',
            example: '0 | 1',
        },
        {
            category: 'Google Workspace',
            name: 'google.customerId',
            description: 'CustomerId from Google',
            example: '',
        },
        {
            category: 'Google Workspace',
            name: 'google.tokens',
            description: 'Token from Google',
            example: '',
        },
        {
            category: 'Google Workspace',
            name: 'google.googleId',
            description: 'GoogleId from Google',
            example: 'awarego.net',
        },
        {
            category: 'Google Workspace',
            name: 'google.testMode',
            description: '(DEPRECATED) Enable test mode in Google integration',
            example: '',
        },
        {
            category: 'Google Workspace',
            name: 'google.enabled',
            description: 'Google Workspace integration is enabled',
            example: '0 | 1',
        },
        {
            category: 'Google Workspace',
            name: 'google.groupBehaviour',
            description: '(DEPRECATED) Google behaviour',
            example: 'include | exclude',
        },
        {
            category: 'Google Workspace',
            name: 'ui.google_allowed',
            description: 'Show Google option in UI - on integration page',
            example: '0 | 1',
        },
        {
            category: 'Azure/SSO',
            name: 'azure.sso.domain',
            description:
                'Domains used by client in emails - usually entered by customer',
            example: 'awarego.com',
        },
        {
            category: 'Azure/SSO',
            name: 'azure.sso.app_name',
            description:
                'Name of app in client azure portal - usually entered by customer',
            example: 'awarego-sso',
        },
        {
            category: 'Azure/SSO',
            name: 'azure.sso.cert',
            description: 'Certificate string - usually entered by customer',
            example: '',
        },
        {
            category: 'Azure/SSO',
            name: 'azuresso.enabled',
            description: 'Is SSO enabled',
            example: '0 | 1',
        },
        {
            category: 'Azure/SSO',
            name: 'azure.sso.<system>.domain',
            description:
                'Domains used by client in emails for specified system (system can be: my,lms,super)',
            example: 'awarego.com',
        },
        {
            category: 'Azure/SSO',
            name: 'azure.sso.<system>.app_name',
            description:
                'Name of app in client azure portal for specified system (system can be: my,lms,super)',
            example: 'awarego-sso',
        },
        {
            category: 'Azure/SSO',
            name: 'azure.sso.<system>.cert',
            description:
                'Certificate string for specified system (system can be: my,lms,super)',
            example: '',
        },
        {
            category: 'Azure/SSO',
            name: 'azuresso.<system>.enabled',
            description:
                'Is SSO enabled for specified system (system can be: my,lms,super)',
            example: '0 | 1',
        },
        {
            category: 'Azure/SSO',
            name: 'azure.sso.tenant',
            description: '(DEPRECATED) Use azure.tenant',
            example: '',
        },
        {
            category: 'Azure/SSO',
            name: 'azure.sso.scope',
            description:
                'Which system is using SSO (Default is all if not set)',
            example: 'my | lms | super',
        },
        {
            category: 'Azure/SSO',
            name: 'azure.emailProps',
            description:
                'Specify which property should be used to get email from profile',
            example:
                'email | http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress | http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name | nameID',
        },
        {
            category: 'Azure/SSO',
            name: 'ui.azure_sso_allowed',
            description: 'Show SSO option in UI - on integration page',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.header',
            description: '(DEPRECATED) HTML to show in heading of emails',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_header',
            description:
                '(DEPRECATED) HTML to show in heading of emails/messages - markdown version, used for slack, teams etc',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.footer',
            description: '(DEPRECATED) HTML to show in footer of emails',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_footer',
            description:
                '(DEPRECATED) HTML to show in footer of emails/messages - markdown version, used for slack, teams etc',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.certificate',
            description:
                '(DEPRECATED) HTML to show in certificate emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_certificate',
            description:
                '(DEPRECATED) HTML to show in certificate emails/messages - markdown version, used for slack, teams etc',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.trainingHeader',
            description: 'HTML header for training emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.trainingFooter',
            description: 'HTML footer for training emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminderTrainingHeader',
            description: 'HTML header for training reminder emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminderTrainingFooter',
            description: 'HTML footer for training reminder emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminderAssessmentHeader',
            description: 'HTML header for assessment reminder emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminderAssessmentFooter',
            description: 'HTML footer for assessment reminder emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.assessmentHeader',
            description: 'HTML header for assessment emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.assessmentFooter',
            description: 'HTML footer for assessment emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.welcomeMessage',
            description: 'HTML for welcome / enrolment email sent to new employees',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_trainingHeader',
            description: 'Markdown header for training (Slack, Teams, etc.)',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_trainingFooter',
            description: 'Markdown footer for training (Slack, Teams, etc.)',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_reminderTrainingHeader',
            description: 'Markdown header for training reminder (Slack, Teams, etc.)',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_reminderTrainingFooter',
            description: 'Markdown footer for training reminder (Slack, Teams, etc.)',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_reminderAssessmentHeader',
            description: 'Markdown header for assessment reminder (Slack, Teams, etc.)',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_reminderAssessmentFooter',
            description: 'Markdown footer for assessment reminder (Slack, Teams, etc.)',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_assessmentHeader',
            description: 'Markdown header for assessment (Slack, Teams, etc.)',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_assessmentFooter',
            description: 'Markdown footer for assessment (Slack, Teams, etc.)',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.mrkdwn_welcomeMessage',
            description: 'Markdown welcome / enrolment message (Slack, Teams, etc.)',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.training_subject',
            description: 'Subject line for training emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminder_training_subject',
            description: 'Subject line for training reminder emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminder_assessment_subject',
            description: 'Subject line for assessment reminder emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.assessment_subject',
            description: 'Subject line for assessment emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.assessment_template_name',
            description:
                'Optional email template folder name under src/emails/ to use instead of the default assessment template (e.g. assessment-rksk)',
            example: 'assessment-rksk',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.assessment_template_language',
            description:
                'Language code for custom assessment email template (date format and i18n). Defaults to da when a custom template is set.',
            example: 'da',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.training_greeting',
            description: 'Greeting text for training emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminder_training_greeting',
            description: 'Greeting text for training reminder emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminder_assessment_greeting',
            description: 'Greeting text for assessment reminder emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.assessment_greeting',
            description: 'Greeting text for assessment emails/messages',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.trainingHeaderEnabled',
            description: 'Whether custom training header is used',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.trainingFooterEnabled',
            description: 'Whether custom training footer is used',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminderTrainingHeaderEnabled',
            description: 'Whether custom training reminder header is used',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminderTrainingFooterEnabled',
            description: 'Whether custom training reminder footer is used',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.assessmentHeaderEnabled',
            description: 'Whether custom assessment header is used',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.assessmentFooterEnabled',
            description: 'Whether custom assessment footer is used',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminderAssessmentHeaderEnabled',
            description: 'Whether custom assessment reminder header is used',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.reminderAssessmentFooterEnabled',
            description: 'Whether custom assessment reminder footer is used',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.welcomeMessageEnabled',
            description: 'Whether custom welcome message is used',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.banner_header',
            description: 'Banner image URL in emails/messages header',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.banner_footer',
            description: 'Banner image URL in emails/messages footer',
            example: '',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.show_social',
            description: 'Show AwareGO social media links in emails/messages',
            example: '0 | 1',
        },
        {
            category: 'Email/Messaging',
            name: 'ui.email.override_account_name',
            description: 'Use company name instead of account name in emails/messages',
            example: '0 | 1',
        },

        {
            category: 'Email/Mailgun',
            name: 'mail.from_email',
            description: 'The email address to send from',
            example: '',
        },
        {
            category: 'Email/Mailgun',
            name: 'mail.from_name',
            description: 'The name of sender for email',
            example: '',
        },
        {
            category: 'Email/Mailgun',
            name: 'mail.mailgun_domain',
            description: 'Domain used for Mailgun',
            example: 'mg.awarego.com',
        },
        {
            category: 'Email/Mailgun',
            name: 'mail.mailgun_host',
            description: 'Mailgun api url - based on region set in mailgun ',
            example: 'api.mailgun.net | api.eu.mailgun.net',
        },
        {
            category: 'Email/Mailgun',
            name: 'mail.mailgun_key',
            description: 'Mailgun key - should always be the same key',
            example: '',
        },
        {
            category: 'Certificate customization',
            name: 'certificate.center_image_url',
            description: 'Path to image to show in center of certificate',
            example: '',
        },
        {
            category: 'Certificate customization',
            name: 'certificate.footer_image_url',
            description: 'Path to image to show in footer of certificate',
            example: '',
        },
        {
            category: 'Certificate customization',
            name: 'certificate.from_name',
            description: 'Name of certifier that appears on certificate',
            example: '',
        },
        {
            category: 'Certificate customization',
            name: 'certificate.use_company_name',
            description:
                'Use company name, instead of account name, as name of certifier that appears on certificate',
            example: '',
        },
        {
            category: 'Development flags',
            name: 'ui.api_allowed',
            description: 'Show open API feature in settings page',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.assessment.recommendations',
            description: 'Show recommendations page in assessment',
            example: '0 | 1',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.assessment.recommendations.custom',
            description:
                'Use custom assessment follow-up recommendations: per-threat-area score threshold, whitelist subjects per area (shared ids assigned once), and optional final-test subjects. Training wizard sets Sync users to Inactive and assigns each module only to employees who failed that area (or all modules if not completed).',
            example: '0 | 1',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.assessment.recommendations.score_threshold',
            description:
                'Per threat-area score threshold. Employees below this score in an area receive that area’s modules (default 70). Not-completed employees receive all modules.',
            example: '70',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.assessment.recommendations.subjects_per_area',
            description:
                'Number of whitelisted training videos to include per threat area in follow-up recommendations (default 1).',
            example: '1',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.assessment.recommendations.subjects_by_area',
            description:
                'JSON map of threat area name to whitelisted training subject id(s). Same subject id under multiple areas is assigned only once. If an area is missing from this map, a random catalog subject for that threat area is used. Example: {"Phishing":[123],"USB devices":[456],"Password handling":[456]}',
            example:
                '{"Phishing":[123],"Sensitive data":[456],"USB devices":[789],"Password handling":[789]}',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.assessment.recommendations.final_test_subjects',
            description:
                'JSON array of subject ids for the follow-up test. Assigned once to any employee who needs follow-up (failed any area or not completed).',
            example: '[999]',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.assessment.recommendations.multi_training',
            description:
                'When custom recommendations are on, show Proposed trainings (group employees by failed threat-area pattern, each user in one training). Default on when unset; set 0 to hide.',
            example: '0 | 1',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.assessment.recommendations.create_as_one',
            description:
                'Show the single combined recommendation section (header, subject grid, “Create as one training…”). Default on when unset; set 0 to hide the whole section and keep only Proposed trainings.',
            example: '0 | 1',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.assessment.recommendations.include_not_completed',
            description:
                'Include a “Not completed” proposed training for employees who did not finish the assessment (all follow-up modules). Default off; set 1 to enable.',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.assessments',
            description: 'Show assessments page',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.auto_reminders',
            description: 'Show auto reminders options',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.cmi5.enabled',
            description:
                'Show scorm/cmi5 generation options for trainings and assessments',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.feedback_enabled',
            description:
                'Show scorm/cmi5 generation options for trainings and assessments',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.assessment_dashboard',
            description: 'Show assessments on dashboard',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.assessment_manual_schedule',
            description: 'Enable sending assessment manually/get signin link',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.certificate_name_change_disabled',
            description:
                '(DEPRECATED) Disable changing user name for certificate',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.posters_url',
            description: '(DEPRECATED) Url for custom poster resources',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.stickers_url',
            description: '(DEPRECATED) Url for custom sticker resources',
            example: '0 | 1',
        },
        {
            category: 'Development flags',
            name: 'ui.iframe_allowed',
            description: 'Allow embedding pages in iframe',
            example: '0 | 1',
        },
        {
            category: 'Customizations and settings',
            name: 'billing.custom',
            description:
                'Usually set for accounts. Whether company/account is billed seperately',
            example: '0 | 1',
        },
        {
            category: 'Customizations and settings',
            name: 'lms_domain',
            description: 'Custom domain for lms page',
            example: 'lms.awarego.com',
        },
        {
            category: 'Customizations and settings',
            name: 'my_domain',
            description: 'Custom domain for my page',
            example: 'my.awarego.com',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.colors.primary',
            description: 'Custom primary color',
            example: '#20A26B',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.colors.secondary',
            description: 'Custom secondary color',
            example: '#AD2931',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.favicon',
            description: 'Url to custom favicon',
            example: '',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.logo',
            description:
                'Url to custom logo - not same value as in company settings, this overrides account logo',
            example: '',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.captions_settings',
            description: 'Custom setting for ppv/embed captions',
            example: '{"color": "yellow"}',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.preset_caption_language',
            description:
                'Make certain captions always show by default (ppv/embed)',
            example: 'Bosnian',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.sendEnrolment',
            description:
                'If new employee enrolment should be on (off by default)',
            example: '0 | 1',
        },
        {
            category: 'Customizations and settings',
            name: 'RUSTICI_ACCOUNT_ID',
            description:
                'Automaticly created when company starts using Scorm/Cmi5 content. Id for company in Rustici system',
            example: '',
        },
        {
            category: 'Customizations and settings',
            name: 'ui.hideLanguageList',
            description:
                'Hide language selector dropdown in training/assessment view (on by default)',
            example: '0 | 1',
        },

        {
            category: 'Scim',
            name: 'scim.secret',
            description: 'Secret for scim integration',
            example: '',
        },
        {
            category: 'Scim',
            name: 'scim.email',
            description: 'Email setting for scim integration',
            example: 'emails.type=work',
        },
        {
            category: 'Google/SSO',
            name: 'sso.my.entry_point',
            description: 'Entry point url for google SSO',
            example: '',
        },
        {
            category: 'Google/SSO',
            name: 'sso.my.issuer',
            description: 'Issuer url for google SSO',
            example: '',
        },
        {
            category: 'Google/SSO',
            name: 'sso.protocol',
            description: 'Protocol for google SSO',
            example: '',
        },
        {
            category: 'Queues',
            name: 'queues.<queue-type-specifics>',
            description:
                'Custom queue for account/company for specific queue type, example name: queues.notificationCreated.training_schedule',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.additional_answer_text.<questionId>',
            description: 'Custom answer text for specific question',
            example:
                '<p>Please report phishing emails by clicking the Report Phish button in Outlook.</p> | mdlz_additional_email_info',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_text',
            description:
                'Custom intro text for assessments. Supports HTML (<p>, <br>, <strong>) or plain text with blank lines between paragraphs.',
            example:
                '<p>First paragraph.</p><p>Second paragraph.</p>',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_text.<languagecode>',
            description:
                'Custom intro text for assessments for specific language. Supports HTML or blank-line paragraph breaks.',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_title',
            description:
                'Custom assessment welcome screen title (falls back to assessment name)',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_title.<languagecode>',
            description:
                'Custom assessment welcome screen title for specific language',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_timer_text',
            description:
                'Custom stopwatch box text. Supports {{time}} placeholder',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_timer_text.<languagecode>',
            description:
                'Custom stopwatch box text for specific language. Supports {{time}}',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_due_text',
            description:
                'Custom due-date line on welcome screen. Supports {{assessmentDueDate}}',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_due_text.<languagecode>',
            description:
                'Custom due-date line for specific language. Supports {{assessmentDueDate}}',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_start_button',
            description: 'Custom label for the Start now button',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_start_button.<languagecode>',
            description:
                'Custom Start now button label for specific language',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'ui.assessments.intro_hide_timer',
            description:
                'Set to 1 to hide the stopwatch focus area on the welcome screen',
            example: '1',
        },
        {
            category: 'Assessment customizations',
            name: 'assessment.additional_info.<threat-area>.link_target',
            description:
                'Url for link in assessment result screen for specified threat area',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'assessment.additional_info.<threat-area>.link_text',
            description:
                'Text for link in assessment result screen for specified threat area',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'assessment.additional_info.<threat-area>.text',
            description:
                'Text for assessment result screen for specified threat area',
            example: '',
        },
        {
            category: 'Assessment customizations',
            name: 'assessment.<assessmentId>.autojoin',
            description:
                'Make assessment with specified id auto-joinable by any user',
            example: '0 | 1',
        },
        {
            category: 'Assessment customizations',
            name: 'assessment.duration',
            description:
                'Customize default duration for scorm/cmi5 assessments',
            example: '',
        },
        {
            category: 'Security (end-user portal MY)',
            name: 'security.my_login_link_validity',
            description: 'How long the login link in emails remains valid for the MY portal',
            example: '1h | 12h | 1d | 1w | 30d',
        },
        {
            category: 'Security (end-user portal MY)',
            name: 'security.my_session_duration',
            description: 'How long the MY portal session stays active',
            example: '1h | 12h | 1d | 1w | 30d',
        },
        {
            category: 'Security (LMS admin portal)',
            name: 'security.lms_login_link_validity',
            description: 'How long the login link in emails remains valid for the LMS',
            example: '1h | 12h | 1d | 1w | 30d',
        },
        {
            category: 'Security (LMS admin portal)',
            name: 'security.lms_session_duration',
            description: 'How long the LMS admin session stays active',
            example: '1h | 12h | 1d | 1w | 30d',
        },
        {
            category: 'Privacy & legal',
            name: 'ui.privacy_url',
            description: 'URL to the company privacy policy page',
            example: 'https://...',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_show_assessment-insight_tab',
            description: 'Show the Assessment Insight / Insights tab in LMS navigation',
            example: '0 | 1',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_hide_assessment-insight_tab',
            description: 'Hide the Assessment Insight tab (takes precedence when set)',
            example: '0 | 1',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_show_phishing-simulation_tab',
            description:
                'Show the Phishing simulation tab (Microsoft Defender AST) in LMS navigation',
            example: '0 | 1',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_hide_phishing-simulation_tab',
            description:
                'Hide the Phishing simulation tab (takes precedence when set)',
            example: '0 | 1',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_hide_trainings_tab',
            description: 'Hide the Training programs tab in LMS',
            example: '0 | 1',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_hide_assessment_tab',
            description: 'Hide the Assessments tab in LMS',
            example: '0 | 1',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_hide_users_tab',
            description: 'Hide the Users tab in LMS',
            example: '0 | 1',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_hide_reports_tab',
            description: 'Hide the Reports tab in LMS',
            example: '0 | 1',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_hide_content_tab',
            description: 'Hide the Content tab in LMS',
            example: '0 | 1',
        },
        {
            category: 'Navigation (LMS)',
            name: 'ui.menu_hide_help_tab',
            description: 'Hide the Help tab in LMS',
            example: '0 | 1',
        },
        {
            category: 'Branding & content (LMS)',
            name: 'ui.content.trainings',
            description: 'Show training subjects in the LMS content area',
            example: '0 | 1',
        },
        {
            category: 'Branding & content (LMS)',
            name: 'ui.content.assessments',
            description: 'Show risk assessment scenarios in the LMS content area',
            example: '0 | 1',
        },
        {
            category: 'Branding & content (LMS)',
            name: 'ui.content.materials',
            description: 'Allow managers to browse reinforcement materials in LMS',
            example: '0 | 1',
        },
        {
            category: 'Branding & content (LMS)',
            name: 'ui.questions-editor',
            description: 'Enable the risk assessment question editor in LMS content',
            example: '0 | 1',
        },
        {
            category: 'Branding & content (LMS)',
            name: 'ui.training.templateStandards',
            description: 'Show the template standards tab for training automations',
            example: '0 | 1',
        },
        {
            category: 'Learner experience',
            name: 'ui.training.skip_auto_finish',
            description: 'Prevent SCORM trainings from auto-completing when requirements are met',
            example: '0 | 1',
        },
        {
            category: 'Learner experience',
            name: 'ui.disable_fast_forward',
            description: 'Disable fast-forward in videos in the MY portal',
            example: '0 | 1',
        },
        {
            category: 'Learner experience',
            name: 'ui.speech_over',
            description: 'Allow text-to-speech for narrative content in learner view',
            example: '0 | 1',
        },
        {
            category: 'Learner experience',
            name: 'ui.scormCertificate',
            description: 'Show certificate download option for SCORM content',
            example: '0 | 1',
        },
        {
            category: 'Training & assessments',
            name: 'ui.trainings.charts',
            description: 'Show training progress charts inside automations',
            example: '0 | 1',
        },
        {
            category: 'Training & assessments',
            name: 'ui.trainings.due',
            description: 'Enable due-date configuration in the training automation wizard',
            example: '0 | 1',
        },
        {
            category: 'Training & assessments',
            name: 'ui.always_show_assessments',
            description: 'Force the Assessments tab to show even without subscription entitlements',
            example: '0 | 1',
        },
        {
            category: 'Training & assessments',
            name: 'ui.certificates_enabled',
            description: 'Allow managers to preview and issue completion certificates',
            example: '0 | 1',
        },
        {
            category: 'Admin & settings visibility',
            name: 'ui.api_keys_hidden',
            description: 'Hide the API Keys section in company Settings',
            example: '0 | 1',
        },
        {
            category: 'Admin & settings visibility',
            name: 'ui.webhooks_hidden',
            description: 'Hide the Webhooks section in company Settings',
            example: '0 | 1',
        },
        {
            category: 'Admin & settings visibility',
            name: 'ui.show_audit',
            description: 'Show the Audit log section in company Settings',
            example: '0 | 1',
        },
        {
            category: 'Admin & settings visibility',
            name: 'ui.iframeMode.allowed',
            description: 'Allow the LMS to be embedded in an iframe (e.g. partner portals)',
            example: '0 | 1',
        },
        {
            category: 'AwareExpose',
            name: 'ui.aware_expose.feature_enabled',
            description:
                'Show the AwareExpose row in LMS Company Settings for this company (platform-level enable). The per-company toggle aware_expose.enabled controls whether the feature actually runs.',
            example: '0 | 1',
        },
        {
            category: 'AwareExpose',
            name: 'aware_expose.allowed_any_domain',
            description:
                'Super-admin override only. When set to 1, AwareExpose accepts any email domain for this company and the LMS "allowed email domains" whitelist is bypassed both in the UI and the API. The whitelisted-domains pill on the MY form is also hidden. Leave unset (or 0) to enforce aware_expose.allowed_email_domains as usual.',
            example: '0 | 1',
        },
        {
            category: 'Insights (HRA) customization',
            name: 'ui.minihra_banner_image_src',
            description: 'Banner image URL for Insights / HRA experience',
            example: 'https://...',
        },
        {
            category: 'Insights (HRA) customization',
            name: 'ui.minihra_banner_link_url',
            description: 'Banner link URL for Insights experience',
            example: 'https://...',
        },
        {
            category: 'Insights (HRA) customization',
            name: 'ui.minihra_finish_url',
            description: 'Finish URL for the "Learn more about HRA" button in Insights',
            example: 'https://...',
        },
        {
            category: 'Menu & navigation labels',
            name: 'ui.menu.label.insights',
            description: 'Label for the Insights / Assessment Insight tab in LMS navigation',
            example: 'Insights | Lead generation Insights',
        },
        {
            category: 'Insights branding',
            name: 'ui.insights.heading',
            description: 'Heading title for Insights section (dashboard, list, empty state)',
            example: 'Insights | Lead generation Insights',
        },
        {
            category: 'URLs & links',
            name: 'ui.help_url',
            description: 'URL for the Help tab / help link in LMS',
            example: 'https://help.awarego.com/',
        },
        {
            category: 'URLs & links',
            name: 'ui.resources_url',
            description: 'Base URL or path for Resources / Content area',
            example: '/resources',
        },
        {
            category: 'URLs & links',
            name: 'ui.terms_url',
            description: 'URL to terms of service',
            example: 'https://www.awarego.com/terms/',
        },
        {
            category: 'URLs & links',
            name: 'ui.check_email_url',
            description: 'URL shown after signup (check your email)',
            example: '',
        },
        {
            category: 'URLs & links',
            name: 'ui.integration_ad_url',
            description: 'Help or documentation URL for Active Directory integration',
            example: '',
        },
        {
            category: 'URLs & links',
            name: 'ui.integration_sso_url',
            description: 'Help or documentation URL for SSO integration',
            example: '',
        },
        {
            category: 'URLs & links',
            name: 'ui.integration_google_url',
            description: 'Help or documentation URL for Google integration',
            example: '',
        },
        {
            category: 'URLs & links',
            name: 'ui.integration_teams_url',
            description: 'Help or documentation URL for Teams integration',
            example: '',
        },
        {
            category: 'URLs & links',
            name: 'ui.integration_slack_url',
            description: 'Help or documentation URL for Slack integration',
            example: '',
        },
        {
            category: 'URLs & links',
            name: 'ui.api_help_url',
            description: 'Help or documentation URL for API Keys section',
            example: '',
        },
        {
            category: 'Support & contact',
            name: 'contact.support',
            description: 'Support contact (e.g. email) shown in UI',
            example: 'support@example.com',
        },
        {
            category: 'Features',
            name: 'ui.reports.tags',
            description: 'Enable tags in reports',
            example: '0 | 1',
        },
        {
            category: 'Features',
            name: 'ui.features.dynamicLists',
            description: 'Enable dynamic lists feature',
            example: '0 | 1',
        },
    ];

    const columns = [
        {
            Header: 'Category',
            accessor: 'category',
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Description',
            accessor: 'description',
        },
        {
            Header: 'Example values',
            accessor: 'example',
        },
    ];

    return (
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            align="center"
            spacing={2}
        >
            <Fragment>
                <Grid item xs={12}>
                    <Typography variant="h2" gutterBottom>
                        Settings Overview
                    </Typography>
                    <SimpleTable
                        columns={columns}
                        data={systemSettings}
                        needsFilter={true}
                    />
                </Grid>
            </Fragment>
        </Grid>
    );
}
export default observer(SettingsOverview);
